import { render } from "./LegendItem.vue?vue&type=template&id=cba3c366&scoped=true"
import script from "./LegendItem.vue?vue&type=script&lang=js"
export * from "./LegendItem.vue?vue&type=script&lang=js"

import "./LegendItem.vue?vue&type=style&index=0&id=cba3c366&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cba3c366"]])

export default __exports__